import React, { ReactNode, useContext } from 'react';
import Error from '../components/Error500';
import GetPagePermission from '../components/GetPagePermission';
import { userPermissionContext } from '../context/UserPagePermission';

interface RequirePagePermissionProps {
	link: string;
	children: ReactNode;
}

/**
 * Shows the page only to roles that have the page link, "Permission Denied" to the others
 * and nothing while the user's page links are still loading.
 */
const RequirePagePermission: React.FC<RequirePagePermissionProps> = ({ link, children }) => {
	const { pagesLinkLoaded } = useContext(userPermissionContext);
	const hasPermission = GetPagePermission(link);

	if (hasPermission === 1) {
		return <>{children}</>;
	}

	return pagesLinkLoaded ? <Error /> : null;
};

export default RequirePagePermission;
